export default __webpack_public_path__ + "static/media/dashboard_group_image.dbddc113.png";